(function () {
  if (window.__temperatureRatingToggleInit) return;
  window.__temperatureRatingToggleInit = true;

  function getRatingBlock(button) {
    return button.closest('.temperature-rating-block, .product-info-drawer__protection-rating');
  }

  function toggleTemperatureUnit(button) {
    const block = getRatingBlock(button);
    if (!block) return;

    const currentUnit = block.querySelector(
      '.temperature-rating__current-unit, .product-info-drawer__protection-rating-current-unit'
    );
    const currentValue = block.querySelector(
      '.temperature-rating__current-value, .product-info-drawer__protection-rating-current-value'
    );
    if (!currentUnit || !currentValue) return;

    const tempCelsius = Number.parseFloat(block.dataset.temperature);
    if (Number.isNaN(tempCelsius)) return;

    const rangeTemps = block.querySelectorAll(
      '.temperature-rating__range-temp, .product-info-drawer__protection-rating-range-temp'
    );
    const pointer = block.querySelector(
      '.temperature-rating__pointer, .product-info-drawer__protection-rating-pointer'
    );
    const toggleText = button.querySelector(
      '.temperature-rating__toggle-text, .product-info-drawer__protection-rating-toggle-text'
    );

    const originalPosition =
      pointer && (pointer.style.left || window.getComputedStyle(pointer).left);

    const isCelsius =
      block.dataset.unit !== 'f' &&
      (currentUnit.textContent.trim() === '°C' || currentValue.textContent.includes('°C'));

    if (isCelsius) {
      const tempFahrenheit = Math.round((tempCelsius * 9) / 5 + 32);
      currentValue.textContent = tempFahrenheit + '°F';
      currentUnit.textContent = '°F';
      block.dataset.unit = 'f';
      if (toggleText) {
        toggleText.textContent =
          button.dataset.switchToC ||
          (typeof Theme !== 'undefined' && Theme.translations?.switch_to_celsius) ||
          'Switch to °C';
      }

      rangeTemps.forEach(function (range) {
        if (range.dataset.fahrenheit) {
          range.textContent = range.dataset.fahrenheit;
        }
      });
    } else {
      currentValue.textContent = tempCelsius + '°C';
      currentUnit.textContent = '°C';
      block.dataset.unit = 'c';
      if (toggleText) {
        toggleText.textContent =
          button.dataset.switchToF ||
          (typeof Theme !== 'undefined' && Theme.translations?.switch_to_fahrenheit) ||
          'Switch to °F';
      }

      rangeTemps.forEach(function (range) {
        if (range.dataset.celsius) {
          range.textContent = range.dataset.celsius;
        }
      });
    }

    if (pointer && originalPosition) {
      pointer.style.left = originalPosition;
      pointer.style.display = 'block';
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-unit-toggle]');
    if (!button) return;

    event.preventDefault();
    toggleTemperatureUnit(button);
  });
})();
